import { useModalContentToggler } from '@components'

import { ToggleGroup, ToggleGroupItem } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CustomerType } from '../../../../enums/customerType'
import { useCustomerForm } from '../../contexts/customerFormContext'

export const CustomerTypeToggle = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { setActiveState } = useModalContentToggler()

  const { FormItem } = customerForm

  const customerTypeItems: ToggleGroupItem[] = useMemo(
    () => [
      {
        icon: 'store',
        value: CustomerType.Company,
        label: t('customer_modal.form.customer_type_toggle.company.label'),
      },
      {
        icon: 'userRound',
        value: CustomerType.Individual,
        label: t('customer_modal.form.customer_type_toggle.individual.label'),
      },
    ],
    [t],
  )

  const handleCustomerTypeToggle = useCallback(
    (onChange: (customerType: CustomerType) => void, value: CustomerType) => {
      setActiveState(value)
      onChange?.(value)
    },
    [setActiveState],
  )

  return (
    <FormItem
      label={t('customer_modal.form.customer_type_toggle.label')}
      name="customerType"
      render={({ field: { onChange, value } }) => {
        return (
          <ToggleGroup
            defaultValue={value}
            items={customerTypeItems}
            onChange={(event) => handleCustomerTypeToggle(onChange, event.currentTarget.value as CustomerType)}
          />
        )
      }}
    />
  )
}
